// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__hLLZq","wrapper-bg":"styles_wrapper-bg__CK9jn","title":"styles_title__QRxcE","cta":"styles_cta__ynO9j","text":"styles_text__EUWFE"};